import React from "react";

/** A simple list of <input type="time"> with add/remove. */
export default function TimesField({ value = [], onChange, label = "Zeiten" }) {
  const times = Array.isArray(value) ? value : [];

  const add = () => onChange?.([...times, "09:00"]);
  const update = (idx, val) => {
    const next = [...times];
    next[idx] = val;
    onChange?.(next);
  };
  const remove = (idx) => onChange?.(times.filter((_, i) => i !== idx));

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="mt-2 space-y-2">
        {times.length === 0 && (
          <div className="text-xs text-gray-500">Noch keine Zeiten hinzugefügt.</div>
        )}
        {times.map((t, i) => (
          <div key={i} className="flex items-center gap-2">
            <input
              type="time"
              value={t || "09:00"}
              onChange={(e) => update(i, e.target.value)}
              className="rounded-md border border-gray-300 px-2 py-1 text-sm"
            />
            <button
              type="button"
              onClick={() => remove(i)}
              className="rounded-md border border-gray-300 px-2 py-1 text-xs text-gray-700 hover:bg-white/70"
            >
              Entfernen
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={add}
          className="inline-flex items-center gap-1 rounded-md border border-gray-300 px-2 py-1 text-xs text-gray-700 hover:bg-white/70"
        >
          <span>＋</span> Zeit hinzufügen
        </button>
      </div>
    </div>
  );
}